import httpClient from './httpClient';

export default {
  fetchAnalyticsV3: (product, integrationSettingsId) =>
    httpClient.get(`api/metrics/v3/analytics/${product}${integrationSettingsId}`),
};
